import { Context, PaginatedResult, mapDtoToEntity } from '../../../common'
import { Api, HttpClient, ProductSuppliesApi } from '../../../api'
import {
  AddProductSupplyOpts,
  PlanReportFindOptions,
  ProductPlansService,
  ProductReport,
  ProductSupply,
} from './productPlans'
import { ProductCategory } from '../../productCategories'

function mapDtoToProductSupply(dto: Api.ProductSupply): ProductSupply {
  return mapDtoToEntity({
    ...dto,
    dataEntryDate: new Date(dto.dataEntryDate),
    category: dto.category as ProductCategory,
  })
}

function mapDtoToProductReport(dto: Api.ProductReport): ProductReport {
  return {
    ...dto,
    category: dto.category as ProductCategory,
  }
}

export class RemoteProductPlansService implements ProductPlansService {
  private api: ProductSuppliesApi

  constructor(httpClient: HttpClient) {
    this.api = new ProductSuppliesApi(httpClient, undefined, '')
  }

  async add(ctx: Context, opts: AddProductSupplyOpts): Promise<string> {
    const result = await this.api.productSuppliesAdd(ctx, { ...opts, dataEntryDate: opts.dataEntryDate.toISOString() })

    return result.body.id
  }

  async findAll(ctx: Context, opts?: PlanReportFindOptions | undefined): Promise<PaginatedResult<ProductSupply>> {
    const result = await this.api.productSuppliesGetList(ctx, {
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
    })

    return {
      ...result.body,
      items: result.body.items.map(mapDtoToProductSupply),
    }
  }

  async planReport(ctx: Context, opts?: PlanReportFindOptions | undefined): Promise<ProductReport[]> {
    const result = await this.api.productSuppliesFormReport(ctx, {
      month: opts?.filter?.month,
      year: opts?.filter?.year,
    })

    return result.body.items.map(mapDtoToProductReport)
  }
}
